import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Content, TDocumentDefinitions } from "pdfmake/interfaces";
import { getDayOfWeek } from "./getDaybyDate";
import { getCorporateNo, getStoreInfo } from "./utils";
(pdfMake.vfs as any) = pdfFonts.vfs;


export const convertImageToBase64 = async (url: string): Promise<string> => {
    try {

        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
            return '';
        }
        const blob = await response.blob();
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error fetching image:', error);
        return '';
    }
};
function getGoogleMapsLink(address: string, postalCode: string): string {
    const fullAddress = `${address || ''} ${postalCode || ''}`.trim();
    const encodedAddress = encodeURIComponent(fullAddress);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
}

export const generatePDF = async (bol: any, user: any, shippingDetails: any, storeList: any) => {
    const logo = './letter_head_final.png';
    const imageDataUrl = await convertImageToBase64(logo);
    // const receiverDetails = getStoreInfo('name', bol.receiver?.name, storeList);
    // const shipperDetails = getStoreInfo('name', bol.shipper?.name, storeList);
    // const corporateNo = getCorporateNo(shipperDetails, receiverDetails);
    const noOfRows = (bol.po?.length ?? 0) < 3 ? 3 : (bol.po?.length ?? 0);
    let contentData: any[] = [
        {
            // Add a rectangle to create a border around the page
            canvas: [
                {
                    type: 'rect',
                    x: 0,
                    y: 0,
                    w: 600, // Width of the page in points (A4 size)
                    h: 780, // Height of the page in points (A4 size)
                    lineColor: 'black',
                    lineWidth: 1,
                    // fillColor: 'blue' // Set to null for no fill
                }
            ]
        },
        {
            columns: [
                {
                    image: imageDataUrl,
                    alignment: 'left',
                    margin: [0, 0, 0, 0],
                    fit: [65, 200], // Add this property to specify the image size
                    style: 'redBackground'
                },
                {
                    table: {
                        widths: [200],
                        body: [
                            [{ text: `BILL OF LADING `, fontSize: 15, bold: true, color: '#04162e' }],
                            [{ text: `6931 Steeles Ave, Toronto, ON, M9K 6K7`, fontSize: 10, margin: [0, -8, 0, 0], color: '#04162e' }],
                            [{ text: `Email:${shippingDetails?.contact ? shippingDetails?.contact[0].email : ''}`, fontSize: 10, margin: [0, -7, 0, 0], color: '#04162e' }],
                        ],
                    }, layout: {
                        defaultBorder: false,
                    }, margin: [-85, -3, 0, 0],
                }, {
                    table: {
                        headerRows: 1,
                        widths: [200, 100],
                        body: [
                            [{ text: `B OF L NO. `, style: 'header', border: true, borderColor: 'white', borderWidth: 3 },
                            { text: `DATE:`, style: 'header', border: true, borderColor: 'white', borderWidth: 3 }],
                            [{ text: bol.bol_no, alignment: 'left', fontSize: 12, style: 'body' },
                            { text: bol.bol_date?.split('T')[0], fontSize: 12, style: 'body' }],
                        ],
                    },
                    alignment: 'right',
                    width: 300,
                    margin: [-21, 0, 0, 0],
                    style: 'table'
                },
            ],
            margin: [0, -780, 0, 0],
        },
        {
            table: {
                headerRows: 1,
                widths: [300, 281],
                body: [
                    [{ text: `SHIPPER `, style: 'header', border: true, borderColor: 'white', borderWidth: 3 },
                    { text: `SHIP TO`, style: 'header', border: true, borderColor: 'white', borderWidth: 3 }],
                    [
                        {
                            table: {
                                headerRows: 1,
                                widths: [80, 212],
                                body: [
                                    [{ text: 'NAME', style: 'title' }, { text: bol.shipper?.name, style: 'data' }],
                                    [{ text: 'ADDRESS', style: 'title' }, { text: bol.shipper?.address, style: 'data', link: getGoogleMapsLink(bol?.shipper?.address, bol?.shipper?.postal_code) }],
                                    [{ text: 'POSTAL CODE', style: 'title' }, { text: bol.shipper?.postal_code, style: 'data', link: getGoogleMapsLink(bol?.shipper?.address, bol?.shipper?.postal_code) }],
                                    [{ text: 'SID NO', style: 'title' }, { text: bol.shipper?.sid_no, style: 'datay' }]
                                ]
                            },
                            margin: [-5, -2, 0, 0]
                        },
                        {
                            table: {
                                headerRows: 1,
                                widths: [80, 190],
                                body: [
                                    [{ text: 'NAME', style: 'title' }, { text: bol.receiver?.name, style: 'data' }],
                                    [{ text: 'ADDRESS', style: 'title' }, { text: bol.receiver?.address, style: 'data', link: getGoogleMapsLink(bol?.receiver?.address, bol?.shipper?.postal_code) }],
                                    [{ text: 'POSTAL CODE', style: 'title' }, { text: bol.receiver?.postal_code, style: 'data', link: getGoogleMapsLink(bol?.receiver?.address, bol?.shipper?.postal_code) }],
                                    [{ text: 'BILL TO', style: 'title' }, { text: bol.corporation_no, style: 'data', background: 'yellow' }]
                                ]
                            },
                            margin: [-3, -2, 0, 0]
                        }
                    ],
                    [{
                        table: {
                            widths: [80, 212],
                            body: [
                                [{ text: 'CARRIER NAME', style: 'title' }, { text: bol.trailer, style: 'data' }],
                                [{ text: 'TRAILER NO.', style: 'title' }, { text: `${bol.info?.trailer_no || ''}`, style: 'data' }],
                                [{ text: 'SEAL NO', style: 'title' }, { text: bol?.info?.seal_no, style: 'data' }],
                            ]
                        },
                        margin: [-5, -3, 0, 0]
                    }, {
                        table: {
                            widths: [80, 190],
                            body: [
                                [{ text: 'SCAC', style: 'title' }, { text: '', style: 'data' }],
                                // loop 2 times and add the data if not then blank join the po_no with /
                                [{ text: 'PO NO.', style: 'title' }, { text: `${bol.po?.map((po: any) => po.po_no).join('/') || ''}`, style: 'data', fontSize: 12, bold: true }]
                            ]
                        },
                        margin: [-3, -3, 0, 0]
                    }],
                    [{
                        table: {
                            headerRows: 1,
                            widths: [301],
                            heights: [10, 44],
                            body: [
                                [{ text: 'SPECIAL INSTRUCTIONS', style: 'title', alignment: 'center' }],
                                [{ text: bol.note, style: 'data', alignment: 'left', color: 'red' },],
                            ]
                        },
                        margin: [-5, -5, 0, 0]
                    }, {
                        table: {
                            widths: [82, 82, 98],
                            body: [
                                [{ text: [{ text: 'FREIGHT CHARGE TERMS \n', style: 'title' }, { text: 'Freight charges prepaid unless marked otherwise', fontSize: 8, style: 'title' }], style: 'title', colSpan: 3 }, {}, {}],
                                [{
                                    table: {
                                        headerRows: 1,
                                        widths: [50, 20],
                                        body: [
                                            [{ text: 'PREPAID', style: 'title' }, { text: '' }],
                                        ],
                                        layout: 'noBorders'
                                    },
                                    margin: [-4, 0, 0, 0],
                                    border: false
                                }, {
                                    table: {
                                        headerRows: 1,
                                        widths: [50, 20],
                                        body: [
                                            [{ text: 'COLLECT', style: 'title' }, { text: '', border: false }],
                                        ]
                                    },
                                    margin: [-4, 0, 0, 0],
                                    border: false
                                }, {
                                    table: {
                                        headerRows: 1,
                                        widths: [70, 18],
                                        body: [
                                            [{ text: 'THIRD PARTY', style: 'title' }, { text: '', border: false }],
                                        ]
                                    },
                                    margin: [-4, 0, 0, 0],
                                    border: false
                                }],
                                [{ text: 'Master bill of lading with attached underlying bills of', colSpan: 3, fillColor: '#cfcfcf', fontSize: 10 }, {}, {}]
                            ]
                        },
                        margin: [-4, -5, 0, 0]
                    }],
                    [{
                        table: {
                            headerRows: 1,
                            widths: [185, 60, 38, 38, 34, 190],
                            body: [
                                [{ text: 'CUSTOMER ORDER NO.', style: 'title' },
                                { text: 'NO OF SKIDS', style: 'title' },
                                { text: 'WEIGHT/PALLET', style: 'title', colSpan: 2 },
                                { text: 'PALLET', style: 'title' },
                                { text: 'SLIP', style: 'title' },
                                { text: 'ADDITIONAL SHIPPER INFO', style: 'title' }
                                ],
                                ...Array(noOfRows).fill(null).map((_, index) => [
                                    { text: `${bol.po?.[index]?.po_no || ''}`, style: 'data' },
                                    { text: `${bol.po?.[index]?.skid || ''}`, style: 'data' },
                                    { text: '', style: 'data' },
                                    { text: 'Y', style: 'data' },
                                    { text: 'N', style: 'data' },
                                    { text: '', style: 'data' },
                                ]),
                                [{ text: 'TOTAL', style: 'title' },
                                { text: (bol.po?.reduce((acc: number, po: { skid: number }) => acc + po.skid, 0) || 0).toString(), style: 'data' },
                                { text: '', style: 'data' },
                                { text: ``, style: 'data', colSpan: 3, fillColor: '#cfcfcf' },
                                { text: '', style: 'data' },
                                { text: '', style: 'data' }
                                ]
                            ]
                        }, margin: [-5, -5, 0, 0], alignment: 'center', colSpan: 2
                    }, {}], [
                        {
                            table: {
                                headerRows: 1,
                                widths: [60, 40, 30, 30, 30, 40, 198, 50, 40],
                                body: [
                                    [{ text: 'STYLE', style: 'title' },
                                    { text: 'TYPE', style: 'title' },
                                    { text: 'QTY', style: 'title' },
                                    { text: 'TYPE', style: 'title' },
                                    { text: 'WGT', style: 'title' },
                                    { text: 'HM(X)', style: 'title' },
                                    { text: 'DESCRIPTION OF ARTICLES, SPECIAL MARKS & EXCEPTIONS', style: 'title' },
                                    { text: 'NMFC NO.', style: 'title' },
                                    { text: 'CLASS', style: 'title' },
                                    ],
                                    [
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: bol.type || ' ', style: 'data', bold: true },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                    ],
                                    [
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: `TOTAL SKIDS: ${bol.po?.reduce((acc: number, po: { skid: number }) => acc + po.skid, 0) || 0}`, style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                    ],
                                    [
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: bol.description || ' ', style: 'data' },
                                        { text: '', style: 'data' },
                                        { text: '', style: 'data' },
                                    ]
                                ]
                            },
                            margin: [-5, -5, 0, 0], alignment: 'center', colSpan: 2
                        }, {}
                    ], [
                        {
                            text: `Where the rate is dependent on value, shippers are required to state specifically in writing the agreed or declared value of the property as follows: "The agreed or declared value of the property is specifaically stated by the shipper to be not exceeding _____________per ____________.`,
                            margin: [-2, -4, 0, 0], alignment: 'justify', fontSize: 10, border: [true, true, true, true]
                        }, {
                            table: {
                                headerRows: 1,
                                widths: [70, 71, 120],
                                body: [
                                    [{ text: 'COD AMOUNT', style: 'title' }, { text: ` `, style: 'data', colSpan: 2 }, {}],
                                    [{ text: 'FEE TERMS', style: 'title', colSpan: 3 }, {}, {}],
                                    [{
                                        table: {
                                            widths: [50, 30],
                                            body: [
                                                [{ text: 'COLLECT', style: 'title' }, { text: `  `, style: 'data' }]
                                            ]
                                        },
                                        margin: [-4, 0, 0, 0], height: 10
                                    },
                                    {
                                        table: {
                                            widths: [50, 15],
                                            body: [
                                                [{ text: 'PREPAID', style: 'title' }, { text: `  `, style: 'data' }]
                                            ]
                                        },
                                        margin: [-4, 0, 0, 0], height: 15
                                    },
                                    {
                                        table: {
                                            widths: [95, 15],
                                            body: [
                                                [{ text: 'CUSTOMER CHECK', style: 'title' }, { text: `  `, style: 'data' }]
                                            ]
                                        },
                                        margin: [-4, 0, 0, 0], height: 20
                                    }],
                                ]
                            },
                            margin: [-4, -4, 0, 0], alignment: 'center',
                            layout: {
                                defaultBorder: false,
                            }

                        }
                    ], [
                        {
                            text: `NOTE: Liability limitation for loss or damage in this shipment may be applicable. See 49 USC § 14706(c)(1)(A) and (B).`,
                            margin: [-2, 0, 0, 0], alignment: 'center', fontSize: 9, border: [true, true, true, true], colSpan: 2, fillColor: '#cfcfcf', bold: true
                        }, {}
                    ], [
                        {
                            text: `Received, subject to individually detemined rates or contracts that have been agreed upon in writing between the carrier and shipper, if applicable, otherwise to thte rates, classifications, and rules that have been established by the carrier and are available to the shipper, on request, and to all applicable state and federal regulations.`,
                            margin: [-2, 0, 0, 0], alignment: 'justify', fontSize: 10, border: [false, false, true, false]
                        }, {
                            table: {
                                widths: [280],
                                body: [
                                    [{ text: 'The carrier shall not make delivery of this shipment without payment of charges and all other lawful fees.', fontSize: 10 }],
                                    [{ text: 'SHIPPER SIGNATURE', style: 'title' }],
                                    [{ text: ' ', border: [false, false, false, false], height: 30 }]
                                ]
                            },
                            margin: [-4, -2, 0, 0], alignment: 'center', layout: {
                                defaultBorder: false,
                            }
                        }
                    ], [
                        {
                            table: {
                                widths: [300, 281],
                                heights: [10, 60, 40],
                                body: [
                                    [{ text: 'SHIPPER SIGNATURE & DATE', style: 'title' }, { text: 'CARRIER SIGNATURE & PICK-UP DATE', style: 'title' }],
                                    [{ text: ' ' }, { text: ' ' }],
                                    [{ text: `(${bol.bol_date?.split('T')[0]}) \n ${getDayOfWeek(bol.bol_date) ?? ''}`, alignment: 'center', fontSize: 20, bold: true }, { text: `(${bol.bol_date?.split('T')[0]}) \n ${getDayOfWeek(bol.bol_date) ?? ''}`, alignment: 'center', fontSize: 20, bold: true }],
                                ],
                            },
                            margin: [-5, -2, 0, 0], alignment: 'center',
                            layout: {
                                defaultBorder: true,
                            }, colSpan: 2,
                        }, {}
                    ]
                ],
            },
            margin: [0, -4, 0, 0],
            layout: {
                defaultBorder: false,
            }
        },
    ];


    // border the entire page
    const docDefinition: TDocumentDefinitions = {
        info: {
            title: `${bol.bol_no}`,
        },
        content: contentData,
        pageSize: 'LETTER',
        pageMargins: [5, 5, 5, 5],
        pageOrientation: 'portrait',
        styles: {
            tabe: {
            },
            header: {
                fillColor: '#04162e',
                color: 'white',
                fontSize: 10,
                bold: true,
                alignment: 'center'
            },
            body: {
                color: 'black',
                fontSize: 15,
                alignment: 'center'
            },
            title: {
                fillColor: '#04162e',
                color: 'white',
                fontSize: 10,
                bold: true,
                alignment: 'left'
            },
            data: {
                fontSize: 10,
                bold: true,
                alignment: 'left'
            }
        },
        background: [
            {
                // Draw a border around the page
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 500,  // A4 width
                        h: 800,  // A4 height
                        lineWidth: 5,
                        lineColor: 'black',
                        fillOpacity: 0,
                    }
                ]
            }
        ]
    };

    // pdfMake.createPdf(docDefinition).open();

    const fileName = `${bol.bol_no}.pdf`;
    pdfMake.createPdf(docDefinition).getBlob((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const newTab = window.open();
        if (newTab) {
            newTab.document.write(`
                <html>
                    <head>
                        <title>${fileName}</title>
                    </head>
                    <body>
                        <embed src="${blobUrl}" width="100%" height="99%" type="application/pdf" />
                        <br/>
                        <a href="${blobUrl}" download="${fileName}">Download ${fileName}</a>
                    </body>
                </html>
            `);
            newTab.document.close();
        }
    });
};